export enum PermissionType {
  'cpl_applicant'= 'CPL Applicant',
  'cpl_admin'= 'CPL Admin',
  'cpl_super_admin' = 'CPL Super Admin',
  'assessments_user'= 'Assessment Engine User',
  'assessments_admin' = 'Assessment Engine Admin',
}